// IATA equipment code → friendly aircraft name (frontend mirror of /app/backend/aircraft_names.py).
// Used by the flight-details timeline which iterates raw amadeus_offer segments.
const NAMES = {
  // Airbus narrowbody
  "318": "Airbus A318", "319": "Airbus A319", "31N": "Airbus A319neo",
  "320": "Airbus A320", "32A": "Airbus A320", "32B": "Airbus A321",
  "32N": "Airbus A320neo", "32Q": "Airbus A321neo", "32S": "Airbus A320 family",
  "321": "Airbus A321",
  // Airbus widebody
  "330": "Airbus A330", "332": "Airbus A330-200", "333": "Airbus A330-300",
  "338": "Airbus A330-800neo", "339": "Airbus A330-900neo",
  "340": "Airbus A340", "342": "Airbus A340-200", "343": "Airbus A340-300",
  "345": "Airbus A340-500", "346": "Airbus A340-600",
  "350": "Airbus A350", "351": "Airbus A350-1000", "359": "Airbus A350-900",
  "35K": "Airbus A350-1000",
  "380": "Airbus A380", "388": "Airbus A380-800",
  // Boeing
  "717": "Boeing 717", "722": "Boeing 727-200", "727": "Boeing 727",
  "732": "Boeing 737-200", "733": "Boeing 737-300", "734": "Boeing 737-400",
  "735": "Boeing 737-500", "736": "Boeing 737-600", "737": "Boeing 737",
  "738": "Boeing 737-800", "739": "Boeing 737-900",
  "73G": "Boeing 737-700", "73H": "Boeing 737-800", "73J": "Boeing 737-900",
  "73W": "Boeing 737-700",
  "7M7": "Boeing 737 MAX 7", "7M8": "Boeing 737 MAX 8",
  "7M9": "Boeing 737 MAX 9", "7MJ": "Boeing 737 MAX 10",
  "742": "Boeing 747-200", "743": "Boeing 747-300", "744": "Boeing 747-400",
  "747": "Boeing 747", "748": "Boeing 747-8", "74Y": "Boeing 747-400F",
  "752": "Boeing 757-200", "753": "Boeing 757-300", "757": "Boeing 757",
  "762": "Boeing 767-200", "763": "Boeing 767-300", "764": "Boeing 767-400",
  "767": "Boeing 767",
  "772": "Boeing 777-200", "773": "Boeing 777-300", "777": "Boeing 777",
  "778": "Boeing 777-8", "779": "Boeing 777-9",
  "77L": "Boeing 777-200LR", "77W": "Boeing 777-300ER",
  "787": "Boeing 787 Dreamliner", "788": "Boeing 787-8 Dreamliner",
  "789": "Boeing 787-9 Dreamliner", "78X": "Boeing 787-10 Dreamliner",
  // Embraer
  "E70": "Embraer 170", "E75": "Embraer 175", "E7W": "Embraer 175",
  "E90": "Embraer 190", "E95": "Embraer 195",
  "E190": "Embraer 190", "E195": "Embraer 195",
  "E290": "Embraer E2-190", "E295": "Embraer E2-195",
  "ER3": "Embraer ERJ-135", "ER4": "Embraer ERJ-140", "ERD": "Embraer ERJ-140",
  "ERJ": "Embraer Regional Jet",
  // Bombardier / Mitsubishi / Airbus A220
  "CR2": "Bombardier CRJ-200", "CR7": "Bombardier CRJ-700",
  "CR9": "Bombardier CRJ-900", "CRA": "Bombardier CRJ-1000",
  "CRK": "Bombardier CRJ-1000",
  "DH1": "Dash 8-100", "DH2": "Dash 8-200", "DH3": "Dash 8-300",
  "DH4": "Dash 8 Q400", "DH8": "Dash 8",
  "BCS": "Airbus A220", "221": "Airbus A220-100", "223": "Airbus A220-300",
  // ATR / Turboprops
  "AT4": "ATR 42", "AT5": "ATR 42-500", "AT7": "ATR 72",
  "ATR": "ATR 72", "AT72": "ATR 72",
  // McDonnell Douglas (legacy)
  "M11": "McDonnell Douglas MD-11", "M80": "McDonnell Douglas MD-80",
  "M82": "McDonnell Douglas MD-82", "M83": "McDonnell Douglas MD-83",
  "M87": "McDonnell Douglas MD-87", "M88": "McDonnell Douglas MD-88",
  "M90": "McDonnell Douglas MD-90", "DC9": "McDonnell Douglas DC-9",
  "D10": "McDonnell Douglas DC-10",
  // Misc
  "BUS": "Bus / Coach", "TRN": "Rail / Train",
};

export function aircraftName(code) {
  if (!code) return "";
  const s = String(code).trim().toUpperCase();
  return NAMES[s] || s;
}
